import React, { useMemo } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import ScheduleIcon from '@material-ui/icons/Schedule';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Box, ListItem, ListItemIcon, ListItemText, Tooltip } from "@material-ui/core";
import UnidadePage from "@pages/UnidadePage";
import LoginPage from "@pages/LoginPage";
import useStorage from "@hooks/useStore";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import EcnhCookies from "@pages/EcnhCookies";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex"
  },
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  menuButtonHidden: {
    display: "none"
  },
  title: {
    flexGrow: 1
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9)
    },
    [theme.breakpoints.down("sm")]: {
      width: 0
    }

  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto"
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column"
  },
  fixedHeight: {
    height: 240
  }
}));

export default function Master() {
  const classes = useStyles();
  const [open, setOpen] = useStorage<boolean>('menuIsOpen');
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const isFrame = useMemo(() => {
    return (window.location != window.parent.location)

  }, [])
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (

    <div className={classes.root}>
      <CssBaseline />
      {isFrame ? null : <>

        <AppBar
          position="fixed"
          className={clsx(classes.appBar, open && classes.appBarShift)}
        >
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(
                classes.menuButton,
                open && classes.menuButtonHidden
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Dashboard
          </Typography>
            {/*<IconButton color="inherit">*/}
            {/*  <Badge badgeContent={4} color="secondary">*/}
            {/*    <NotificationsIcon />*/}
            {/*  </Badge>*/}
            {/*</IconButton>*/}
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose)
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List>
            <div>

              <Link to="/">
                <Tooltip title="Busca unidades" placement="right" >
                  <ListItem button>
                    <ListItemIcon>
                      <HomeWorkIcon />
                    </ListItemIcon>
                    <ListItemText primary="Unidades" />
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/ecnh-cookies">
                <Tooltip title="Cookies" placement="right" >
                  <ListItem button>
                    <ListItemIcon>
                      <ScheduleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Cookies" />
                  </ListItem>
                </Tooltip>
              </Link>
            </div>
            <div>
              <Tooltip title="Sair" placement="right" >

                <ListItem button onClick={() => {
                  localStorage.clear();
                  window.location.reload()
                }}>
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText primary="Sair" />


                </ListItem>
              </Tooltip>
            </div>
          </List>
          {/*
        <Divider />
        <List>{secondaryListItems}</List> */}
        </Drawer>

      </>}

      <main className={classes.content}>
        {isFrame ? null : <div className={classes.appBarSpacer} />}
        <Container maxWidth="lg" className={classes.container}>

          <Switch>
            <Route path="/login">
              <LoginPage />
            </Route>

            <Route path="/ecnh-cookies">
              <EcnhCookies />
            </Route>
            <Route path="/">
              <UnidadePage />
            </Route>
          </Switch>


        </Container>
      </main>
    </div>

  );
}
